import styled from 'styled-components';
import { clearTextFieldStyles } from './css';

export const ClearTextArea = styled.textarea`
  ${clearTextFieldStyles};

  &:focus {
    background-color: ${props => props.theme.secondaryBackgroundColor};
  }
`;

export default ClearTextArea;
